import { render, staticRenderFns } from "./CardOrderSummary.vue?vue&type=template&id=2a090648&scoped=true"
import script from "./CardOrderSummary.vue?vue&type=script&lang=js"
export * from "./CardOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./CardOrderSummary.vue?vue&type=style&index=0&id=2a090648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a090648",
  null
  
)

export default component.exports